/* ButterCo gift-with-purchase (gifts by cart value).
   Free items are fixed as part of every cart change (removed before a product goes, added after one comes in),
   and the page only hears the change is finished once the free items are right too.
   A background check still runs afterwards as a safety net, and the checkout gate in
   snippets/bc-freebies.liquid waits for both. */
(function(){
var C=window.BC_FREEBIES;if(!C||!C.rules)return;
var R=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
var FREE={};(C.all||[]).forEach(function(id){FREE[id]=1});
var S=window.BCF=window.BCF||{};
S.dirty=true;S.pending=S.pending||0;S.busy=false;
var noAdd=false,timer=null,runP=null,again=false;
var RE=/\/cart\/(add|change|update|clear)/;
var H={'Content-Type':'application/json',Accept:'application/json'};
function j(u,o){o=o||{};o.__bc=1;return fetch(u,o)}
function isFree(l){return !!((l.properties&&l.properties._freebie)||FREE[l.variant_id])}
/* Gifts go by how much the customer pays for products (cart subtotal, paise):
   rules [{amt,ids}] — e.g. any order: Stickers; ₹999+: + Scrunchie; ₹1,599+: + Scalp Massager. */
function linePrice(l){return l.price!=null?l.price:(l.final_line_price!=null?l.final_line_price:0)}
function amtOf(items,cld){var a=0;items.forEach(function(l){if(!isFree(l)&&l.quantity>0)a+=linePrice(l)});return Math.max(0,a-(cld||0))}
function cldOf(cart){return Math.max(0,((cart&&cart.items_subtotal_price)||0)-((cart&&cart.total_price)||0))}
function wantFromAmt(a){if(!(a>0))return [];var out=[];(C.rules||[]).slice().sort(function(x,y){return x.amt-y.amt}).forEach(function(r){if(a>=r.amt)out=r.ids.slice()});return out}
/* What has to change in the free items for a cart with these lines. */
function plan(items,amt){
  var w=wantFromAmt(amt==null?amtOf(items):amt),ws={};w.forEach(function(id){ws[id]=1});
  var have={},upd={},n=0;
  items.forEach(function(l){if(isFree(l)&&l.quantity>0){if(have[l.variant_id]){upd[l.key]=0;n++}else{have[l.variant_id]=1;var q=ws[l.variant_id]?1:0;if(l.quantity!==q){upd[l.key]=q;n++}}}});
  var add=w.filter(function(id){return !have[id]});
  return {upd:upd,nUpd:n,add:noAdd?[]:add};
}
function addBody(ids){return {items:ids.map(function(id){return {id:id,quantity:1,properties:{_freebie:'1'}}})}}
function jsonResp(c){return new Response(JSON.stringify(c),{status:200,headers:{'Content-Type':'application/json; charset=utf-8'}})}
function readCart(){return j(R+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()})}
/* Apply a plan to the live cart; returns the final cart. */
async function applyPlan(p,cart){
  if(p.add.length){var a=await j(R+'cart/add.js',{method:'POST',headers:H,body:JSON.stringify(addBody(p.add))});if(!a.ok)noAdd=true}
  if(p.nUpd){var u=await j(R+'cart/update.js',{method:'POST',headers:H,body:JSON.stringify({updates:p.upd})});if(u.ok)return u.json()}
  if(p.add.length)return readCart();
  return cart;
}
function cachedCart(){try{return window.BCCartCache&&BCCartCache.get()}catch(e){return null}}
function parse(b){if(typeof b!=='string')return null;try{return JSON.parse(b)}catch(e){return null}}
/* Predict the lines after a change/update request, from the cart we already have. */
function predictChange(cart,kind,body){
  var items=cart.items.map(function(l){return {key:l.key,variant_id:l.variant_id,quantity:l.quantity,properties:l.properties,unit:l.quantity?(l.final_line_price/l.quantity):(l.final_price||0),price:l.final_line_price}});
  function set(id,q){var hit=false;items.forEach(function(l,i){if(!hit&&(l.key===String(id)||String(l.variant_id)===String(id))){l.quantity=q;l.price=Math.round(l.unit*q);hit=true}});return hit}
  if(kind==='change'){
    if(body.properties||body.selling_plan!==undefined)return null;
    var q=+body.quantity;if(isNaN(q))return null;
    if(body.line!=null){var l=items[+body.line-1];if(!l)return null;l.quantity=q;l.price=Math.round(l.unit*q);return {items:items,updates:(function(){var o={};o[l.key]=q;return o})()}}
    if(body.id==null||!set(body.id,q))return null;
    var o={};o[String(body.id)]=q;return {items:items,updates:o};
  }
  if(kind==='update'){
    if(!body.updates||Array.isArray(body.updates)||body.attributes||body.note!==undefined||body.discount!==undefined)return null;
    for(var k in body.updates){if(!set(k,+body.updates[k]))return null}
    return {items:items,updates:body.updates};
  }
  return null;
}
/* How many free items the cart will gain (+) or lose (-) if this product's quantity becomes q.
   Lets product pages and cards show the right cart count straight away. */
window.bcFreebieDeltaFor=function(vid,q){try{var cc=cachedCart();if(!cc)return 0;
  var PR=window.BC_PRICE||{};
  var lines=cc.items.map(function(l){return {key:l.key,variant_id:l.variant_id,quantity:l.quantity,properties:l.properties,price:l.final_line_price,unit:l.quantity?l.final_line_price/l.quantity:0}}),hit=false;
  lines.forEach(function(l){if(!isFree(l)&&l.variant_id==vid){l.quantity=hit?0:q;l.price=Math.round((l.unit||PR[vid]||0)*l.quantity);hit=true}});
  if(!hit&&q>0){if(PR[vid]==null)return 0;lines.push({key:'new',variant_id:+vid,quantity:q,properties:{},price:PR[vid]*q})}
  var p=plan(lines,amtOf(lines,cldOf(cc))),d=p.add.length;
  lines.forEach(function(l){if(Object.prototype.hasOwnProperty.call(p.upd,l.key))d+=p.upd[l.key]-l.quantity});
  return d}catch(e){return 0}};
/* ---- background safety net (same as before) ---- */
async function once(){
  var cart=await readCart();
  var p=plan(cart.items||[],cart.total_price);
  if(!p.nUpd&&!p.add.length)return false;
  await applyPlan(p,cart);
  document.dispatchEvent(new CustomEvent('bc:freebies'));
  return true;
}
function run(){
  if(S.pending){later();return Promise.resolve()}
  if(runP){again=true;return runP}
  S.busy=true;
  runP=(async function(){
    var n=0,ch;
    do{again=false;try{ch=await once()}catch(e){ch=false}n++}while((again||ch)&&n<4);
    runP=null;S.busy=false;if(!S.pending)S.dirty=false;
  })();
  return runP;
}
function later(){clearTimeout(timer);S.sched=true;timer=setTimeout(function(){S.sched=false;run()},60)}
function idle(ms){return new Promise(function(res){var t0=Date.now();(function c(){if(!S.pending||Date.now()-t0>ms)res();else setTimeout(c,40)})()})}
/* Lets the cart drawer and header wait until a cart change (with its free items) has fully finished. */
S.idle=function(){return new Promise(function(res){var t0=Date.now();(function c(){if((!S.pending&&!S.busy&&!S.sched)||Date.now()-t0>8000)res();else setTimeout(c,40)})()})};
S.ensure=function(){return idle(6000).then(function(){clearTimeout(timer);S.sched=false;return run()}).then(function(){if(S.dirty&&!S.pending)return run()})};
function mark(){S.dirty=true;S.pending++}
function done(){S.pending=Math.max(0,S.pending-1);later()}
/* ---- inline handling of cart requests made by the theme ----
   Order is always safe: free items that stop qualifying are removed BEFORE the product change,
   free items that start qualifying are added AFTER it. The page only hears back once both are done,
   so its loading state covers the whole thing and a free item never sits in the cart on its own. */
var of=window.fetch;
function predictLines(cart,kind,body){
  if(kind==='change'||kind==='update'){var pr=predictChange(cart,kind,body);return pr&&pr.items}
  if(kind==='add'){
    var list=body.items?body.items:(body.id?[{id:body.id,quantity:body.quantity||1}]:null);
    if(!list||list.some(function(x){return FREE[x.id]}))return null;
    var PR=window.BC_PRICE||{};if(list.some(function(x){return PR[x.id]==null}))return null;
    var lines=cart.items.map(function(l){return {key:l.key,variant_id:l.variant_id,quantity:l.quantity,properties:l.properties,price:l.final_line_price}});
    list.forEach(function(x){var q=+(x.quantity||1);lines.push({key:'new',variant_id:+x.id,quantity:q,properties:x.properties||{},price:PR[x.id]*q})});
    return lines;
  }
  return null;
}
function handle(self,a,url){
  var init=a[1]||{},body=parse(init.body),kind=/\/cart\/change/.test(url)?'change':/\/cart\/update/.test(url)?'update':/\/cart\/add/.test(url)?'add':/\/cart\/clear/.test(url)?'clear':'other';
  var js=/\.js(\?|$)/.test(url);
  function orig(){return of.apply(self,a)}
  if(!js||kind==='other'||kind==='clear'||!body)return orig().then(function(r){return after(r,kind,null)});
  var cc=cachedCart();
  return (cc?Promise.resolve(cc):readCart().catch(function(){return null})).then(function(cart){
    var lines=cart&&predictLines(cart,kind,body);
    if(!lines)return orig().then(function(r){return after(r,kind,null)});
    var p=plan(lines,amtOf(lines,cldOf(cart)));
    var hdr={'Content-Type':'application/json',Accept:'application/json'};
    /* Fast path for adds: the product and any free items it unlocks go in ONE request, and the same
       request returns the new cart (via the bc-cart-json section), so nothing has to be fetched afterwards. */
    if(kind==='add'&&!p.nUpd&&!body.sections&&!body.sections_url&&!body.attributes&&body.note===undefined){
      var single=!body.items,list=single?[{id:body.id,quantity:body.quantity||1,properties:body.properties||{}}]:body.items.slice();
      if(single&&body.selling_plan)list[0].selling_plan=body.selling_plan;
      var nb={items:list.concat(p.add.length?addBody(p.add).items:[]),sections:'bc-cart-json'};
      return j(url,{method:'POST',headers:hdr,body:JSON.stringify(nb)}).then(function(r){
        if(!r.ok){if(!p.add.length)return r;return orig().then(function(o){if(o.ok)noAdd=true;return o})}
        return r.clone().json().then(function(d){
          try{var h=d.sections&&d.sections['bc-cart-json'];if(h){var c=JSON.parse(h.slice(h.indexOf('>')+1,h.lastIndexOf('<')));
            (c.items||[]).forEach(function(i){if(typeof i.image==='string'&&i.image.indexOf('//')===0)i.image='https:'+i.image});
            if(!c.token&&cart&&cart.token)c.token=cart.token;if(window.BCCartCache&&BCCartCache.set)BCCartCache.set(c)}}catch(e){}
          delete d.sections;return jsonResp(single?((d.items||[])[0]||d):d);
        }).catch(function(){return r});
      }).catch(function(){return orig()});
    }
    if(!p.nUpd&&!p.add.length)return orig();
    if((kind==='change'||kind==='update')&&!p.add.length&&!body.sections){
      var pr=predictChange(cart,kind,body);
      if(pr&&pr.updates){
        var up={};Object.keys(p.upd).forEach(function(k){up[k]=p.upd[k]});Object.keys(pr.updates).forEach(function(k){up[k]=pr.updates[k]});
        return j(R+'cart/update.js',{method:'POST',headers:hdr,body:JSON.stringify({updates:up})}).then(function(r){return r.ok?r:orig()}).catch(function(){return orig()});
      }
    }
    /* 1. remove the free items that will no longer qualify */
    var pre=p.nUpd?j(R+'cart/update.js',{method:'POST',headers:H,body:JSON.stringify({updates:p.upd})}).catch(function(){}):Promise.resolve();
    /* 2. the product change itself, exactly as the page asked */
    return pre.then(orig).then(function(r){
      if(!r.ok||!p.add.length)return r;
      /* 3. add the free items that now qualify */
      return j(R+'cart/add.js',{method:'POST',headers:H,body:JSON.stringify(addBody(p.add))}).then(function(ar){
        if(!ar.ok)noAdd=true;
        if(kind==='add')return r;
        return readCart().then(function(c){return jsonResp(c)});
      }).catch(function(){return r});
    });
  });
}
/* After a request we could not fold: fix the free items before the page hears back. */
async function after(r,kind,cart){
  if(!r.ok)return r;
  try{
    var full=(kind==='change'||kind==='update'||kind==='clear');
    var c=full?await r.clone().json():await readCart();
    var p=plan(c.items||[],c.total_price);
    if(!p.nUpd&&!p.add.length)return r;
    var fin=await applyPlan(p,c);
    return full&&fin&&fin.items?jsonResp(fin):r;
  }catch(e){return r}
}
window.fetch=function(){var a=arguments,u=a[0];u=(u&&u.url)||u||'';var ext=typeof u==='string'&&RE.test(u)&&!(a[1]&&a[1].__bc)&&(!a[1]||!a[1].method||String(a[1].method).toUpperCase()==='POST');
  if(!ext)return of.apply(this,a);
  mark();var p;try{p=handle(this,a,u)}catch(e){p=of.apply(this,a)}p.then(done,done);return p};
var ox=XMLHttpRequest.prototype.open,os=XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.open=function(m,u){this.__bcu=u;return ox.apply(this,arguments)};
XMLHttpRequest.prototype.send=function(){if(typeof this.__bcu==='string'&&RE.test(this.__bcu)){mark();this.addEventListener('loadend',done)}return os.apply(this,arguments)};
if(document.readyState!=='loading')later();else document.addEventListener('DOMContentLoaded',later);
window.addEventListener('pageshow',later);
document.addEventListener('visibilitychange',function(){if(!document.hidden){S.dirty=true;later()}});
})();
